<!--suppress ALL -->
<template>
	<v-select
		:clearable="clearable"
		:items="options"
		v-model="surveyor"
		item-value="id"
		:label="$t('pages.surveyerSelect')"
		:item-text="userName"
		:multiple="multiple"/>
</template>

<script>
	import UserModule from "src/store/modules/User.module";
	import SelectMixin from "src/mixins/SelectMixin";
	import {types as RoleTypes} from "dev/helpers/RoleManager";

	export default {
		name: "surveyor-select",
		data() {
			return {
				search: {
					role: RoleTypes.SURVEYORS
				}
			};
		},
		props: {
			multiple: {default: true},
			value: {default: null},
			clearable: {default: true},
			label: {default: "בחר מודד"}
		},
		computed: {
			surveyor: {
				get() {
					return this.value;
				},
				set(val) {
					this.$emit("input", val);
				}
			}
		},
		components: {},
		methods: {
			userName(item) {
				return [item.name, item.last_name].join(" ");
			},
		},
		mixins: [new SelectMixin(UserModule, "users")],
	};
</script>
